

export class WizardIndicatorsData {
    private _Momentum_1:number =0;
    private _Momentum_2:number =0;
    private _Momentum_3:number =0;
    private _Volatility:number =0;
    private _BuyingSelling:number =0;


    set Momentum_1(v:number)
    {
        this._Momentum_1 = v;
    }

    get Momentum_1():number
    {
        return this._Momentum_1;
    }

    set Momentum_2(v:number)
    {
        this._Momentum_2 = v;
    }

    get Momentum_2():number
    {
        return this._Momentum_2;
    }

    set Momentum_3(v:number)
    {
        this._Momentum_3 = v;
    }

    get Momentum_3():number
    {
        return this._Momentum_3;
    }

    set Volatility(v:number)
    {
        this._Volatility = v;
    }

    get Volatility():number
    {
        return this._Volatility;
    }

    set BuyingSelling(v:number)
    {
        this._BuyingSelling = v;
    }

    get BuyingSelling():number
    {
        return this._BuyingSelling;
    }



}